import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgB3 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7220_21628)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 100,
				height: 100,
				fill: "#00ABFF"
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter0_d_7220_21628)",
				children: /* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M64.2845 16.0077C62.7802 15.0287 60.8401 15.0287 59.3358 16.0077L34.1103 32.4253C30.3271 34.8875 32.0707 40.7631 36.5846 40.7631H40.2766C40.995 40.7631 41.5335 41.4233 41.3511 42.1181C39.6503 48.5992 35.5416 54.0476 29.9463 56.8512L26.9223 58.3664C18.8549 62.4086 13.267 70.9696 11.9353 80.752C11.5974 83.2343 13.6602 85.2748 16.1654 85.2748H49.9268C52.432 85.2748 54.4157 83.2421 54.5013 80.7384C54.6624 76.0244 55.4631 71.9665 59.3535 69.6546L65.5109 65.4945C73.5684 60.7061 78.2185 51.8568 79.3801 41.7931C79.4474 41.2105 79.9354 40.7631 80.5218 40.7631H87.0357C91.5496 40.7631 93.2932 34.8875 89.51 32.4253L64.2845 16.0077Z",
					fill: "url(#paint0_linear_7220_21628)"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M53.0195 43.3129C53.0195 42.0603 54.035 41.0449 55.2875 41.0449C56.5401 41.0449 57.5556 42.0603 57.5556 43.3129V45.581C57.5556 46.8336 56.5401 47.849 55.2875 47.849C54.035 47.849 53.0195 46.8336 53.0195 45.581V43.3129Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M59.8262 43.3129C59.8262 42.0603 60.8416 41.0449 62.0942 41.0449C63.3468 41.0449 64.3622 42.0603 64.3622 43.3129V45.581C64.3622 46.8336 63.3468 47.849 62.0942 47.849C60.8416 47.849 59.8262 46.8336 59.8262 45.581V43.3129Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M71.7725 60.2423C69.9858 62.2995 67.8979 64.0744 65.5109 65.4929L59.3535 69.653C55.4631 71.965 54.6624 76.0228 54.5013 80.7369C54.4157 83.2406 52.432 85.2733 49.9268 85.2733H16.1654C13.6602 85.2733 11.5974 83.2327 11.9353 80.7504C13.267 70.968 18.8549 62.4071 26.9223 58.3649L29.9463 56.8497C30.2635 56.6907 30.5759 56.5233 30.8834 56.3477L42.6219 62.4615C43.4075 62.8706 44.2957 63.0408 45.1769 62.9511L71.7725 60.2423Z",
				fill: "url(#paint1_linear_7220_21628)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M22.4655 61.6353L30.9727 65.998C32.3774 66.7184 34.0188 66.8205 35.5019 66.2799L43.758 63.2704L46.8794 66.8867C48.0645 68.2597 49.8349 68.983 51.6424 68.8324L60.1227 68.1258C61.6068 68.0022 63.0511 67.5604 64.3006 66.7501C67.205 64.8664 70.5418 62.3213 71.9691 60.4707C72.1128 60.2844 71.9602 60.0332 71.726 60.0562L44.0564 62.7689L31.4479 56.2048C31.2867 56.1209 31.0954 56.1191 30.933 56.2006C27.7837 57.782 24.0001 59.8082 22.4042 61.1937C22.259 61.3197 22.2944 61.5476 22.4655 61.6353Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_7220_21628",
			x: -8.10107,
			y: -4.72656,
			width: 119.681,
			height: 110.002,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 10 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_7220_21628"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_7220_21628",
					result: "shape"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_7220_21628",
			x1: 51.7394,
			y1: 15.2734,
			x2: 51.7394,
			y2: 85.2748,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#A0E1FD" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CFEFFC"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_7220_21628",
			x1: 41.943,
			y1: 56.2793,
			x2: 41.943,
			y2: 85.2729,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#004A80" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0068A8"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_7220_21628",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 100,
				height: 100,
				fill: "white"
			})
		})
	] })]
});
export default SvgB3;
